import { toast } from "sonner";

const collectEmails = (players, fields) => {
  const set = new Set();
  for (const p of players) for (const f of fields) if (p[f]) set.add(p[f].trim());
  return [...set].filter(Boolean);
};

export const emailListsFor = (players) => ({
  guardians: collectEmails(players, ["guardian_email"]),
  players: collectEmails(players, ["player_email"]),
});

export const allEmails = (players) => collectEmails(players, ["guardian_email", "player_email"]);

// BCC everyone so addresses stay private; leave "to" empty for the coach's mail client.
export const openBccMail = (list, subject, body) => {
  window.location.href = `mailto:?bcc=${encodeURIComponent(list.join(","))}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export function mailGroup(list, kind, posFilter, programName) {
  if (list.length === 0) return toast.error(`No ${kind} emails in this group`);
  const progName = programName || "Our Program";
  const subject = posFilter
    ? `${progName} — ${posFilter} ${kind === "guardian" ? "Parents" : "Group"}`
    : `${progName} — Team Update`;
  const groupLabel = posFilter
    ? `${posFilter} ${kind === "guardian" ? "parents" : "players"}`
    : (kind === "guardian" ? "team parents" : "team");
  openBccMail(list, subject, `Hi ${groupLabel},\n\n(Type your message here.)\n\n— Coach\nGridiron OS`);
}

export function broadcastProgram(list, programName) {
  if (list.length === 0) return toast.error("No emails on the roster yet");
  if (!window.confirm(
    `Broadcast to the entire program?\n\n` +
    `This opens your mail app with ${list.length} address${list.length === 1 ? "" : "es"} ` +
    `(players + guardians) on BCC. Nothing sends until you hit Send in your mail app.`
  )) return;
  openBccMail(list, `${programName || "Our Program"} — Program Announcement`,
    `Team Family,\n\n(Type your announcement here.)\n\n— Coach\nGridiron OS`);
}
